<template>
  <div>
    <div
      v-if="filteredRows"
      class="modal-container"
      @keydown.esc="closeForm()"
      @click.stop
    >
      <form class="px-4 py-5 modal-content filter-table">
        <div class="d-flex justify-content-between">
          <h2 class="text-capitalize pb-4 px-2 mb-0 header">Compare Surveys</h2>
          <div class="cursor-pointer">
            <span @click="closeForm()"> <close-svg /> </span>
          </div>
        </div>
        <div class="mb-5">
          <input
            ref="formInput"
            class="survey-title pb-2 px-4 text-capitalize"
            placeholder="Search"
            type="text"
            v-model="filterSurveys"
          />
        </div>

        <div class="mb-5 text-info px-4 table-content overflow-auto">
          <table class="w-100">
            <thead>
              <tr class="main-row">
                <td class="outer-td w-100">
                  <table class="w-100">
                    <tr>
                      <!-- surveyGroupName -->
                      <th>Name</th>
                      <th>year</th>
                      <th>Round</th>
                      <th>Score</th>
                      <th>Count</th>
                    </tr>
                  </table>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(survey, index) in filteredRows"
                :key="`employee-${index}`"
                class="outer-row"
              >
                <td class="outer-td py-2">
                  <div class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      :id="'survey-' + index"
                      :value="survey.surveyId"
                      v-model="checkedIds"
                      class="d-none"
                      ref="checkboxs"
                    />
                    <label :for="'survey-' + index" class="w-100">
                      <table
                        class="w-100 info-table"
                        :class="{
                          'active-row': checkedIds.includes(survey.surveyId),
                        }"
                      >
                        <tr>
                          <td
                            v-html="highlightMatches(survey.surveyGroupName)"
                          ></td>
                          <td v-html="highlightMatches(survey.year)"></td>
                          <td
                            v-html="highlightMatches(`R${survey.quarter[1]}`)"
                          ></td>
                          <td
                            v-html="
                              highlightMatches(
                                survey.avgScore.toFixed(2).toString()
                              )
                            "
                          ></td>
                          <td
                            v-html="highlightMatches(survey.total.toString())"
                          ></td>
                        </tr>
                        <div class="position-absolute right-sign">
                          <img
                            class="img-fluid"
                            alt="selected"
                            src="@/assets/images/create-survey/right_sign.svg"
                          />
                        </div>
                      </table>
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="text-center">
          <button class="border-0 btn-start" @click.prevent="letsGo()">
            <a class="text-capitalize py-3 px-5 d-block">let's go!</a>
          </button>
          <br />
          <small
            v-if="compareInvalid"
            class="text-danger text-capitalize px-4 mt-4 d-inline-block"
            >you must select 1-3 surveys :)</small
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TableSearchManager from "@/manager/TableSearchManager";
export default {
  name: "SelectSurveysForCompare",

  data() {
    return {
      checkedIds: [],
      filterSurveys: "",
      compareInvalid: false,
    };
  },

  computed: {
    surveyType() {
      return this.$store.getters["mainStats/getSurveyTypeForCompare"];
    },
    filteredRows() {
      return TableSearchManager.filteredRows(
        this.$store.getters["mainStats/getDataForCompareTable"],
        this.filterSurveys
      );
    },

    routeQuery() {
      return this.$route.query.surveyId;
    },
  },

  methods: {
    closeForm() {
      this.$store.dispatch("mainStats/hideSelectSurveys");
    },

    letsGo() {
      if (this.checkedIds.length < 2 || this.checkedIds.length > 3) {
        this.compareInvalid = true;
      } else {
        this.compareInvalid = false;
        if (
          !this.routeQuery ||
          this.routeQuery.length !== this.checkedIds.length
        ) {
          this.routeQuery
            ? this.$router
                .replace({
                  name: "compareSurveys",
                  query: {type: this.surveyType, surveyId: this.checkedIds },
                })
                .catch(() => {})
            : this.$router
                .push({
                  name: "compareSurveys",
                  query: {type: this.surveyType, surveyId: this.checkedIds },
                })
                .catch(() => {});
        } else if (this.routeQuery.length === this.checkedIds.length) {
          let idsNotChanges = this.routeQuery.every((v) =>
            this.checkedIds.includes(v)
          );

          if (!idsNotChanges) {
            this.$router
              .replace({
                name: "compareSurveys",
                query: { type: this.surveyType, surveyId: this.checkedIds },
              })
              .catch(() => {});
          }
        }

        this.$store.dispatch("mainStats/hideSelectSurveys");
      }
    },

    highlightMatches(text) {
      return TableSearchManager.highlightMatches(text, this.filterSurveys);
    },
  },

  async mounted() {
    if (this.$route.query.surveyId) {
      this.$route.query.surveyId.forEach((item) => {
        this.checkedIds.push(+item);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
table {
  td,
  th {
    width: 12.5rem;
  }

  th {
    text-transform: capitalize;
  }
  .index-cell {
    width: 6.25rem;
  }
}
</style>
